var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FCDBBE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3335 9.3335C11.3335 8.9655 11.6322 8.66683 12.0002 8.66683C12.3682 8.66683 12.6668 8.9655 12.6668 9.3335C12.6668 9.7015 12.3682 10.0002 12.0002 10.0002C11.6322 10.0002 11.3335 9.7015 11.3335 9.3335ZM11.3335 11.3335C11.3335 10.9655 11.6322 10.6668 12.0002 10.6668C12.3682 10.6668 12.6668 10.9655 12.6668 11.3335V14.6668C12.6668 15.0348 12.3682 15.3335 12.0002 15.3335C11.6322 15.3335 11.3335 15.0348 11.3335 14.6668V11.3335ZM12.0002 17.3335C9.0595 17.3335 6.66683 14.9408 6.66683 12.0002C6.66683 9.0595 9.0595 6.66683 12.0002 6.66683C14.9408 6.66683 17.3335 9.0595 17.3335 12.0002C17.3335 14.9408 14.9408 17.3335 12.0002 17.3335ZM12.0002 5.3335C8.31816 5.3335 5.3335 8.31816 5.3335 12.0002C5.3335 15.6822 8.31816 18.6668 12.0002 18.6668C15.6815 18.6668 18.6668 15.6822 18.6668 12.0002C18.6668 8.31816 15.6815 5.3335 12.0002 5.3335Z",
    fill: "#E37617"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupInfo);
export default __webpack_public_path__ + "static/media/groupInfo.0ad36d5d8720d2714cd34a00afb43534.svg";
export { ForwardRef as ReactComponent };